import * as React from "react";
import { DEFAULT_LANGUAGE, Language } from "../types/types";

export const LanguageContext = React.createContext<Language>(DEFAULT_LANGUAGE);
